<template>
  <div id="app">
    <HtmlHeader />
    <router-view></router-view> <!-- 路由视图容器 -->
  </div>
</template>

<script>
import HtmlHeader from './components/HtmlHeader.vue';

export default {
  name: 'App',
  components: {
    HtmlHeader
  }
}
</script>

<style>
:root {
  --primary: #FF9800;
  --primary-light: #FFB74D;
  --primary-dark: #F57C00;
  --secondary: #37474F;
  --light: #f9f9f9;
  --gray: #78909C;
  --dark: #263238;
}

body {
  background: linear-gradient(135deg, #fdf6e3 0%, #fff3e0 100%);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
